import { notificationFilter, notificationPriority } from '@/api/notifications/types';
import WarningIcon from '@/assets/svg/ui-elements/alert-circle-orange.svg';
import { theme, Tooltip, Typography } from '@/design-system';
import { colors } from '@/design-system/colors';
import { settingsTabKeys } from '@/pages/settings/settings-tab-keys';
import { useGetAllNotifications } from '@/pages/settings/utils/use-get-all-notifications';
import { PagePaths } from '@/routes/page-paths';

import { NotificationMessagesButton, NotificationsBadge } from './NotificationMessages.styled';

export const NotificationMessages = () => {
  const notifications = useGetAllNotifications({ filter: notificationFilter.NEW });

  const highPriorityNotifications = notifications.filter(
    (notification) => notification.priority === notificationPriority.HIGH,
  );

  const message = highPriorityNotifications?.[0]?.title || '';
  const tooltipDisabled = message.length <= 28;

  if (!highPriorityNotifications.length) return null;

  return (
    <NotificationMessagesButton to={`${PagePaths.settings}?tab=${settingsTabKeys.notifications}`}>
      <WarningIcon width={14} height={14} />

      <Tooltip disabled={tooltipDisabled} title={message} side="bottom" align="start">
        <Typography
          variant="body4"
          color={colors.orange.solid}
          noWrap
          style={{ maxWidth: '216px', fontFamily: theme.typography.fontFamily.mono }}
        >
          {message}
        </Typography>
      </Tooltip>

      <NotificationsBadge>
        <Typography
          variant="body5"
          fontWeight={500}
          style={{ fontFamily: theme.typography.fontFamily.mono }}
        >
          +{highPriorityNotifications.length > 9 ? '9' : highPriorityNotifications.length}
        </Typography>
      </NotificationsBadge>
    </NotificationMessagesButton>
  );
};
